import { lazyLoadView } from '@router/routes'
import store from '@state/store'
import { AUTHS } from '@state/modules/auth'

export default [
  // 인증
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => lazyLoadView(import('@views/auth/register.vue')),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       if (store.getters[AUTHS.NAMESPACE(AUTHS.GET_CURRENT_USER)]) {
  //         // 로그인이 되어 있으면 홈으로 이동
  //         next({ name: 'home' })
  //       } else {
  //         next()
  //       }
  //     },
  //   },
  // },

  // 로그인
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/auth/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters[AUTHS.GET_CURRENT_USER]) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },

  // 로그아웃
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch(AUTHS.NAMESPACE(AUTHS.LOGOUT))
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.meta.authRequired)
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
]
